(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-filter"]) return;
  try {
    
$( document ).ready(function() {
  if ($('.collection-filters').hasClass('filters-surfaces')) {
    $('.featured-products').each(function() {
      $(this).addClass('filterable');
      var collectionCats = $(this).data('cats').split(' ');
      var collectionHandle = $(this).data('term');
      var collectionTitle = $(this).data('title');
      $.each(collectionCats, function(index, value) {
        if (value != '') {
          console.log(value);
          console.log(collectionTitle); 
          $('.filter-cat[data-cat="' + value + '"] .filter-terms .v-flex').append(' <div class="term flex" data-term="' + collectionHandle + '"><span>' + collectionTitle + '</span></div>'); 
        }
      });
    });
    
  }
    
});
  
// filter toggles
$('.filter-toggle-wrap').click(function() {
  $(this).find('.filter-toggle').toggleClass('active');
  updateFilter();
});

// filter terms
$('.filters-select').on('click', '.term', function() {
  console.log(1); 
    $(this).toggleClass('active');
    var $cat = $(this).closest('.filter-cat');
    console.log($cat.data('cat'));
    if ($cat.find('.term.active').length > 0) {
        $cat.addClass('active');
    } else {
        $cat.removeClass('active');
    }
    updateFilter();
});

// filter update
function updateFilter() {

  // terms
  var selectedTags = $('.term.active').map(function() {
    return $(this).data('term');
  }).get();
  console.log('terms:', selectedTags); 
  
  if ($('.collection-filters').hasClass('filters-surfaces')) {

    $('.featured-products').removeClass('hide');
    $('.featured-products').each(function() { 
      var term = $(this).data('term');
      if (selectedTags.length === 0 || selectedTags.includes(term)) {} else {
        $(this).addClass('hide'); 
      }
    });
    
  } else {

    $('#product-grid li').show();
    $('#product-grid li').each(function() {
      var productTags = $(this).data('terms').split(' ');
      if (selectedTags.length === 0 || selectedTags.some(tag => productTags.includes(tag))) {} else {
        $(this).hide();
      }
    });
    // toggles
    $('.filter-toggle.active').each(function() {
      var term = $(this).data('term');
      console.log('toggle:', term);
      $('#product-grid li').each(function() {
        if ($(this).data(term) != true) {
          $(this).hide();
        }
      });
    });
    // scroll
    $('.section-featured-product .image-with-text').removeClass('show');
    /*$('html, body').animate({
      scrollTop: $('#product-grid').offset().top
    }, 1000);*/
    
  }
}

// filter reset {
var rotate = 0;
$('.filter-reset-wrap').click(function() {
  rotate -= 360;
  $(this).find('svg').css('transform', 'rotate(' + rotate.toString() + 'deg)');
  $('.filters-select .filter-cat.active, .filters-select .term.active, .filter-toggle.active').removeClass('active');
  $('#product-grid li').show();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery"] && !window.DesignMode) return;
  try {
    
// filter terms
$('.gallery-filter-options .button').click(function() {
  $(this).toggleClass('active');
  var $cat = $(this).parent().parent().parent().parent('.gallery-filter-cat');
  if ($cat.find('.button.active').length > 0) {
    $cat.addClass('active');
  } else {
    $cat.removeClass('active');
  }
  updateFilter();
});

// reveal
function reveal(blocks) {
  var limit = $('.gallery-panel').data('paginate');
  var blocks = $('.gallery-item-wrap.stage:not(.show)');
  for (var i = 0; i < limit && i < blocks.length; i++) {
    (function(index) {
      var block = blocks.eq(index);
      setTimeout(function() {
        block.addClass('show'); 
      }, index * 150);
    })(i);
  }
  if (blocks.length <= limit) {
    $('.load-more').addClass('disabled');
  } else {
    $('.load-more').removeClass('disabled'); 
  }
}

// filter update
function updateFilter() { 
  $('.gallery-item-wrap').removeClass('show');
  $('.gallery-item-wrap').removeClass('stage');
  // terms
  var selectedTags = $('.gallery-filter-options .button.active').map(function() { 
    return $(this).data('term');
  }).get();
  console.log('terms:', selectedTags)
  $('.gallery-item-wrap').each(function() {
    var productTags = $(this).data('terms').split(' ');
    if (selectedTags.length === 0 || selectedTags.some(tag => productTags.includes(tag))) {
      $(this).addClass('stage');
    }
  });
  reveal();
}

// filter reset {
var rotate = 0;
$('.filter-reset-wrap').click(function() {
  rotate -= 360;
  $(this).find('svg').css('transform', 'rotate(' + rotate.toString() + 'deg)');
  $('.gallery-filter-cat, .gallery-filter-options .button').removeClass('active');
  $('.gallery-item-wrap').removeClass('show');
  $('.gallery-item-wrap').addClass('stage');
  reveal();
});

// filter close
$('.gallery-filter-cat .x').click(function() {
  $('.gallery-filter-cat.expanded').removeClass('expanded');
});

// load more
$('.load-more').click(function() {
  reveal();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !window.DesignMode) return;
  try {
     
$( document ).ready(function() { 
  $('.hero-home .slider').slick({ 
    infinite: true,
    adaptiveHeight: true
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
    var productAttrs = document.querySelectorAll('.product-attr');
    if (productAttrs.length > 0) {
        productAttrs[productAttrs.length - 1].classList.add('last'); 
    }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !window.DesignMode) return;
  try {
     
$( document ).ready(function() { 
  $('.reviews .slider').slick({ 
    infinite: true,
    adaptiveHeight: true
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["showrooms"] && !window.DesignMode) return;
  try {
    
$(window).load(function(){
  $('.map-nav .location[data-id="0"] .expand-btn').trigger('click');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !window.DesignMode) return;
  try {
    
function arrows() {
  var sliderWidth = $('.testimonials .slider').width() / 2;
  var dotsWidth = $('.testimonials .slick-dots').width() / 2;
  $('.testimonials .slick-prev').css('left', sliderWidth - dotsWidth - 25);
  $('.testimonials .slick-next').css('left', sliderWidth + dotsWidth + 8); 
}
  
$(document).ready(function() {
  $('.testimonials .slider').on('init', function(event, slick) {
    arrows();
    $('.testimonials .slick-arrow').show();
  });
  $('.testimonials .slider').slick({ 
    infinite: true,
    adaptiveHeight: true,
    dots: true
  });
});

$(window).resize(function() {
  arrows(); 
});

  } catch(e) { console.error(e); }
})();
})();
